import api from "Common/Client/Interceptor";

const BASE_URL = "/indv/Experts/Profile";

export const fetchExpertProfile = async (token) => {
  try {
    const response = await api.get(BASE_URL, {
      headers: {
        accept: "*/*",
        Authorization: `Bearer ${token}`,
      },
    });
    return response;
  } catch (error) {
    console.error("Error fetching Expert profile:", error);
    throw error;
  }
};


export const updateExpertProfile = async (token, values, fileList) => {
  try {
    const formData = new FormData();

    // Add image file if present
    if (fileList?.length > 0 && fileList[0]?.originFileObj) {
      formData.append("ImageFile", fileList[0].originFileObj);
    }

    const queryParams = new URLSearchParams();

    queryParams.append("FirstName", values.firstName || "");
    queryParams.append("LastName", values.lastName || "");
    queryParams.append("PhoneNo", values.phoneNo || "");
    queryParams.append("Country", values.country || "");
    queryParams.append("State", values.state || "");
    queryParams.append("City", values.city || "");
    queryParams.append("YearsOfExperience",values.yearsOfExperience ?? 0);
    
    console.log("Updating profile with params:", Object.fromEntries(queryParams));

    const response = await api.put(
      `${BASE_URL}?${queryParams.toString()}`,
      formData,
      {
        headers: {
          accept: "*/*",
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      }
    );

    return response;
  } catch (error) {
    console.error("Error updating Expert profile:", error);
    throw error;
  }
};

export const removeExpertProfilePicture = async (token) => {
  return api.delete(`${BASE_URL}/Picture`, {
    headers: { accept: "*/*", Authorization: `Bearer ${token}` },
  });
};
